import {nextTick} from 'vue'
export const beforeEach = (to, from, store) => {
	const adminMain = document.querySelector('#adminui-main')
	if (!adminMain) {
		return false
	}
	store.commit('updateViewTags', {
		fullPath: from.fullPath,
		scrollTop: adminMain.scrollTop
	})
}
export const afterEach = (to,from, store) => {
	const adminMain = document.querySelector('#adminui-main')
	if (!adminMain) {
		return false
	}
	nextTick(() => {
		const beforeRoute = store.state.viewTags.viewTags.filter((v) => v.fullPath == to.fullPath)[0]
		if (beforeRoute) {
			adminMain.scrollTop = beforeRoute.scrollTop || 0
		}
	})
}
export default {
	beforeEach, afterEach
}
